{
  "name": "@wayke-se/ev-web",
  "version": "0.1.1",
  "description": "Wayke Electric Vehicle Web",
  "module": "dist/index.mjs",
  "main": "dist/index.js",
  "types": "dist/index.d.ts",
  "type": "module",
  "scripts": {
    "start": "node ./esbuild/start.js",
    "build": "npm run clean && node ./esbuild/lib.js && node ./esbuild/cdn.js",
    "clean": "rimraf build && rimraf dist && rimraf dist-cdn",
    "test": "npm run lint && npm run typecheck",
    "typecheck": "tsc -noEmit",
    "typecheck:watch": "tsc -noEmit -watch",
    "lint": "eslint --ext .ts,.js src/",
    "lint:fix": "eslint --ext .ts,.js 'src' --fix",
    "stylelint": "stylelint '**/*.scss'",
    "prepare": "husky install",
    "clip": "node ./esbuild/clip-ui.js && node ./clip-ui/start.js"
  },
  "author": "Wayke",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/wayke-se/ev-web/issues"
  },
  "homepage": "https://github.com/wayke-se/ev-web#readme",
  "devDependencies": {
    "@ourstudio/clip-ui": "^0.0.11",
    "@types/node": "^18.15.11",
    "@typescript-eslint/eslint-plugin": "^6.7.3",
    "@typescript-eslint/parser": "^6.7.3",
    "esbuild": "^0.19.4",
    "esbuild-sass-plugin": "^2.15.0",
    "eslint": "^8.9.0",
    "eslint-config-prettier": "^9.0.0",
    "eslint-plugin-prettier": "^5.0.0",
    "husky": "^8.0.1",
    "npm-dts": "^1.3.11",
    "prettier": "^3.0.3",
    "rimraf": "^5.0.5",
    "stylelint": "^15.3.0",
    "stylelint-config-prettier-scss": "^1.0.0",
    "stylelint-config-standard-scss": "^11.0.0",
    "typescript": "^5.0.2"
  },
  "files": [
    "dist"
  ],
  "dependencies": {
    "i18next": "^23.5.1"
  }
}
